module.exports = __webpack_public_path__ + "static/media/menu-herbier.cf1f072c.svg";